export const NOTE_TITLE_COLORS = ['#f8f8f8', 'rgba(0,0,0,.85)'];
export const NOTE_CONTENT_COLORS = ['#f8f8f8', 'rgba(0,0,0,.60)'];

export const NOTE_BACKGROUND_COLORS = [
  '#F57F2C',
  '#FFEEA7',
  '#74AB7D',
  '#8ED1FC',
  '#0693E3',
  'white',
  '#ED574F',
  '#A736E7',
];
